export default __webpack_public_path__ + "static/media/spinslots.a479cbfb.png";